import { oc } from '@orpc/contract';
import { createUserInputSchema, userWithTemporaryPasswordSchema } from '../schemas/users.schemas.js';
export const createUserContract = oc
    .route({
    method: 'POST',
    path: '/users',
    tags: ['Users'],
    summary: 'Create an account with a one-time temporary password the user must change at first sign-in (ADMIN)',
})
    .input(createUserInputSchema)
    .output(userWithTemporaryPasswordSchema);
//# sourceMappingURL=create-user.contract.js.map